module.exports = __webpack_public_path__ + "img/9-1.af1cef42.jpg";